export const DEFAULT_TEAM_CLAIM_NAME = 'https://redocly.com/sso/teams';
export var AuthProviderType;
(function (AuthProviderType) {
  AuthProviderType["OIDC"] = "OIDC";
  AuthProviderType["SAML2"] = "SAML2";
  AuthProviderType["BASIC"] = "BASIC";
})(AuthProviderType || (AuthProviderType = {}));
export var ApigeeDevOnboardingIntegrationAuthType;
(function (ApigeeDevOnboardingIntegrationAuthType) {
  ApigeeDevOnboardingIntegrationAuthType["SERVICE_ACCOUNT"] = "SERVICE_ACCOUNT";
  ApigeeDevOnboardingIntegrationAuthType["OAUTH2"] = "OAUTH2";
})(ApigeeDevOnboardingIntegrationAuthType || (ApigeeDevOnboardingIntegrationAuthType = {}));
export const REDOCLY_TEAMS_RBAC = 'redocly::teams-rbac';
export var LayoutVariant;
(function (LayoutVariant) {
  LayoutVariant["STACKED"] = "stacked";
  LayoutVariant["THREE_PANEL"] = "three-panel";
})(LayoutVariant || (LayoutVariant = {}));